import { useApi } from '@/composables/src/useApi'
import http from '@/composables/src/useHttp'

export const getTogglWorkspaces = (togglApiToken: string) => {
  return useApi(
    http.post('/integrations/toggl/workspaces', {
      togglApiToken,
    }),
  )
}

export const getTogglReport = (togglApiToken: string, workspaceId: number, startDate?: string, endDate?: string) => {
  return useApi(
    http.post('/integrations/toggl/report', {
      togglApiToken,
      workspaceId,
      startDate,
      endDate,
    }),
  )
}

// Simple time entries fetch (API v9 - FAST)
export const getTogglTimeEntries = (togglApiToken: string, workspaceId: number, startDate: string, endDate: string) => {
  return useApi(
    http.post('/integrations/toggl/time-entries', {
      togglApiToken,
      workspaceId,
      startDate,
      endDate,
    }),
  )
}

// Summary by tags (API v3 - SUPER FAST, returns total only)
export const getTogglSummaryByTags = (
  togglApiToken: string,
  workspaceId: number,
  projectId: number,
  startDate: string,
  endDate: string,
  tags: string[],
) => {
  return useApi(
    http.post('/integrations/toggl/summary-by-tags', {
      togglApiToken,
      workspaceId,
      projectId,
      startDate,
      endDate,
      tags,
    }),
  )
}

export const getTogglSummary = (togglApiToken: string, workspaceId: number, startDate?: string, endDate?: string) => {
  return useApi(
    http.post('/integrations/toggl/summary', {
      togglApiToken,
      workspaceId,
      startDate,
      endDate,
    }),
  )
}

export const getTogglProjects = (togglApiToken: string, workspaceId: number, startDate?: string, endDate?: string) => {
  return useApi(
    http.post('/integrations/toggl/projects', {
      togglApiToken,
      workspaceId,
      startDate,
      endDate,
    }),
  )
}

export const startTogglTimeEntry = (
  togglApiToken: string,
  workspaceId: number,
  description: string,
  projectId?: number,
  tags?: string[],
) => {
  return useApi(
    http.post('/integrations/toggl/start', {
      togglApiToken,
      workspaceId,
      description,
      projectId,
      tags,
    }),
  )
}

export const getCurrentTogglTimeEntry = (togglApiToken: string) => {
  return useApi(
    http.post('/integrations/toggl/current', {
      togglApiToken,
    }),
  )
}

// Silent version for background checks (doesn't show error toasts)
export const getCurrentTogglTimeEntrySilent = async (togglApiToken: string) => {
  try {
    const response = await http.post('/integrations/toggl/current', {
      togglApiToken,
    })

    return { data: response.data, error: null }
  } catch (error: any) {
    return {
      data: null,
      error: {
        message: error.response?.data?.details || error.response?.data?.error || error.message || 'Failed to fetch timer',
      },
    }
  }
}

export const stopTogglTimeEntry = (togglApiToken: string, workspaceId: number, timeEntryId: number) => {
  return useApi(
    http.post('/integrations/toggl/stop', {
      togglApiToken,
      workspaceId,
      timeEntryId,
    }),
  )
}
